<template>
  <bim-row class="block-head">
    <bim-col cols=12 md=8>
      <img alt="" src="/dist/assets/front_white/img/landing_gisp/img-footer-logo-minpromtorg-color.svg" class="block-head__logo pb-10 pr-9" />
      <img alt="" src="/dist/assets/front_white/img/landing_gisp/img-footer-logo-gisp-color.svg" class="block-head__logo pb-10" />

      <img alt="" src="/dist/assets/front_white/img/landing_gisp/group.svg" class="block-head__image" />
      <bim-text type="h4" class="block-head__title" bold>Сервис BIMLIB – цифровой паспорт продукции для участия в проектной деятельности</bim-text>
      <bim-text class="mt-10 block-head__text" type="main">BIMLIB способствует росту продаж вашей продукции благодаря обеспечению возможности прямого попадания в проекты капитального строительства на частном и государственных рынках.</bim-text>
      <bim-text class="mt-10 block-head__text" type="main">Через цифровые паспорта продукции мы соединяем САПР-спецификацию заказчика и каталог производителя на самых ранних этапах формирования проекта. Сервис повышает эффективность маркетинговых кампаний, позволяя получать актуальную аналитику о проектных потребностях вашей продукции с разбивкой по регионам.</bim-text>
      <bimRow class="d-flex justify-center justify-md-start">
        <ButtonTryService class="mt-10" />
      </bimRow>
    </bim-col>
  </bim-row>
</template>

<script>
import bimRow from "@bimlib/components/bimRow"
import bimCol from "@bimlib/components/bimCol"

import ButtonTryService from "./ButtonTryService"
export default {
  name: "BlockHead",
  components: {
    bimRow,
    bimCol,

    ButtonTryService
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/grid-settings";

.block-head {
  padding: 81px 0;
  position: relative;
  z-index: 0;

  @media screen and (max-width: $breakpoint-sm) {
    padding: 20px 0;
  }

  .block-head__image {
    position: absolute;
    top: 0;
    right: 0;
    z-index: -1;
    height: 100%;
  }

  .block-head__title {
    line-height: 1.14;
  }

  .block-head__text {
    line-height: 1.5;
    letter-spacing: 0.2px;
    width: 65%;
  }

  @media screen and (max-width: $breakpoint-xl) {
    .block-head__image {
      width: 80%;
    }
  }

  @media screen and (max-width: $breakpoint-md) {
    .block-head__text {
      width: 100%
    }

    .block-head__image {
      display: none;
    }
  }
}
</style>
